import React, { FC } from 'react'
import { createSelector } from '@reduxjs/toolkit'

import './index.less'
import { useTranslation } from 'react-i18next'
import { CardinalApiState, login, provideSelectedEnvironment, refuseEnvironmentSelection } from '../../../core/services/auth.api'
import { useAppDispatch, useAppSelector } from '../../../core/hooks'
import { CustomModal } from '../../common/CustomModal'
import { AccountSelection } from './AccountSelection'
import { trimUserGroupsMatches, UserGroupMappedType, userGroupMapper } from '../../../helpers/groups'
import { Alert } from 'antd'

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    environmentSelectionRequested: cardinalApi.environmentSelectionRequested,
    availableGroupsToLogin: cardinalApi.availableGroupsToLogin,
  }),
)

export interface EnvironmentType {
  color: string
  bgColor: string
  accounts: UserGroupMappedType[]
}

export const ModalChooseEnvironment: FC = () => {
  const { t }: { t: (key: string, ctxt?: { [key: string]: string }) => string } = useTranslation()

  const dispatch = useAppDispatch()
  const { environmentSelectionRequested, availableGroupsToLogin } = useAppSelector(reduxSelector)

  const environment: EnvironmentType = {
    color: '#f6a40b',
    bgColor: '#5a3903',
    accounts: trimUserGroupsMatches(availableGroupsToLogin ?? []).map(userGroupMapper),
  }

  const handleAccountSelect = (account: UserGroupMappedType) => {
    dispatch(provideSelectedEnvironment(account.id))
    dispatch(login())
  }

  const handleClose = () => dispatch(refuseEnvironmentSelection())

  return (
    <CustomModal
      isVisible={environmentSelectionRequested}
      handleClose={handleClose}
      secondaryBtnTitle={t('auth.chooseEnvironmentForm.close')}
      title={t('auth.chooseEnvironmentForm.title')}
    >
      <div className="modalChooseEnvironment">
        <Alert showIcon message={t('auth.chooseEnvironmentForm.alert')} />
        <AccountSelection environment={environment} onAccountSelect={(account: UserGroupMappedType) => handleAccountSelect(account)} />
      </div>
    </CustomModal>
  )
}
